/**
 * JavaScriptでフラッシュメッセージを表示する
 * @param type メッセージの種類 ("success" | "error" | "info" | "warning")
 * @param message 表示するメッセージ
 */
export const showFlashMessage = (type: "success" | "error" | "info" | "warning", message: string): void => {
  // アイコンクラスを決定（デフォルトはチェックマーク）
  let iconClass = "fa-solid fa-check me-2";
  if (type === "error") {
    iconClass = "fa-solid fa-triangle-exclamation me-2";
  } else if (type === "info") {
    iconClass = "fa-solid fa-info-circle me-2";
  } else if (type === "warning") {
    iconClass = "fa-solid fa-exclamation-circle me-2";
  }

  const flashHtml = `
    <p class="flashMsg ${type} js_flashMsg is_active" data-controller="flash-message">
      <i class="${iconClass}"></i>
      ${message}
    </p>
  `;

  // mainタグを見つけて、その子要素の一番上にメッセージを表示する
  const mainElement = document.querySelector("main");
  if (mainElement) {
    // 既存のフラッシュメッセージを削除
    const existingFlashes = mainElement.querySelectorAll(".flashMsg.js_flashMsg");
    existingFlashes.forEach((flash) => {
      if (flash.parentElement) {
        flash.parentElement.removeChild(flash);
      }
    });

    // 新しいフラッシュメッセージを追加
    mainElement.insertAdjacentHTML("afterbegin", flashHtml);
  }
};
